import App from "../components/Sidebar.svelte";

const app = new App({
  target: document.body,
});

export default app;
